import React, {
  useState
  // useRef,
  // , useEffect
}
  from 'react';
import { AutoCenter, Image, FloatingBubble } from 'antd-mobile'
// import { request } from '@/utils'

import { useSearchParams } from 'react-router-dom';
import './index.scss'
import { MessageFill } from 'antd-mobile-icons'





// const IconFont = createFromIconfontCN({
//   scriptUrl: '//at.alicdn.com/t/c/font_4335219_nhipwl2o8u8.js',
// });


const M1 = () => {

  const [urlp] = useSearchParams()
  const [visible, setVisible] = useState(urlp.get('dw') === 'yz' ? true : false)


  const token = 'wxbb3b1b7a793d10f4'
  const url = encodeURIComponent(window.location.href)
  const ddsppurl = encodeURIComponent(`http://www.ddspp.com/wx?g=pid&dw=yz&reurl=${url}`)

  //  const turl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${token.appid}&redirect_uri=${ddsppurl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
  const turl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${token}&redirect_uri=${ddsppurl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`





  console.log("t=" + urlp.get("t"))



  console.log(visible)
  ///请求 返回json  写入

  return <>

 


    <AutoCenter>

      <Image
        src='sy.png'
        width={228}
        height={228}
        fit='cover'
        style={{ borderRadius: 114, marginTop: '189px' }}
      />




<FloatingBubble
        style={{
          '--initial-position-bottom': '24px',
          '--initial-position-right': '24px',
          '--edge-distance': '24px',
        }}
        onClick={() => {
          urlp.get('code') !== null ? setVisible(true) : window.location.href = turl
        }}
      >
        <MessageFill fontSize={32} />
      </FloatingBubble>


    </AutoCenter>


  </>
}

export default M1;